import { Component, OnInit, Inject, ViewChild, ElementRef, HostBinding } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';

@Component({
	selector: 'common-confirm-dialog',
	templateUrl: './confirm-dialog.component.html',
	styleUrls: ['./confirm-dialog.component.scss']
})
export class ConfirmDialogComponent implements OnInit {
	@HostBinding('class.confirm-dialog-theme') hostClass = true;
	@ViewChild('removeView', { static: true })
	removeView: ElementRef;

	constructor(public dialogRef: MatDialogRef<ConfirmDialogComponent>, @Inject(MAT_DIALOG_DATA) public data: string) {}

	onNoClick(): void {
		this.dialogRef.close();
	}

	ngOnInit() {
		this.removeView.nativeElement.parentElement.parentElement.style = 'padding:0px';
	}
}
